<template>
  <div class="">

    <Head />


    <div class="main reservation">
      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('參觀預約') }}</li>
          </ol>
        </div>
      </nav>


      <div class="calendar_box reservation_box">

        <div class="container">

          <div class="title_box">
            <h2>{{ $t('參觀預約') }}</h2>
          </div>

          <div class="text_box">
            <p>{{ $t('【導覽解說預約須知】') }}
              <br>
              {{ $t('隆田文化資產教育園區為全國第一座文化資產為主題之教育園區，並以「推廣臺南文化資產」、「文化資產教育資源整合」與「臺南文化資產國際交流」三大願景持續推進，提供導覽解說服務') }}
              <br>
              <br>
              {{ $t('辦理【團體參觀預約】者（無導覽需求），請點選【團體預約】按鈕進入申請') }}
              <br>
              {{ $t('辦理【導覽解說預約】者，請點選【導覽預約】按鈕進入申請') }}
            </p>
          </div>


          <div class="calendar">

            <div class="" ref="calendar"></div>

          </div>

        </div>

      </div>




    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'


import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import zhTw from "@fullcalendar/core/locales/zh-tw"  // 引入繁體中文

// 行事曆休館日
const REST_DAY = 3 // 星期三


export default {
  name: 'Reservation',
  components: {
    Head,
    Footer,

    AccesskeyLink,

    Calendar,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
    zhTw,

  },

  data() {
    return {

      // 行事曆
      calendar: null,

      // 假日資料
      holidayData: [],

      // 新增：自訂截止報名日期和內文
      customClosedDates: {
        // 這裡可以手動設定特定日期的關閉訊息
        // '2026-01-20': '農曆新年假期不開放預約導覽，造成不便敬請見諒',
      },

      // 儲存各日期的額滿狀態
      dateAvailability: {},

    };
  },


  async mounted() {
    await this.loadHolidayData()
    this.initCalendar()
  },

  methods: {
    // 載入假日資料
    async loadHolidayData() {
      try {
        const response = await fetch('/data/2026.json')
        this.holidayData = await response.json()
      } catch (error) {
        console.error('載入假日資料失敗:', error)
      }
    },

    // 檢查是否為假日
    isHoliday(date) {
      const dateStr = this.formatDateForHoliday(date)
      const holiday = this.holidayData.find(h => h.date === dateStr && h.isHoliday)
      return holiday
    },

    // 格式化日期為 YYYYMMDD 格式（用於假日比對）
    formatDateForHoliday(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    },

    // 檢查日期是否額滿
    async checkDateAvailability(date) {
      try {
        const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaGroupReg/Public/GetAvailableSlots?date=${dateStr}`
        
        const response = await fetch(apiUrl, {
          method: 'GET',
        })
        
        const data = await response.json()
        
        if (data.ok) {
          // 檢查是否所有時段都已額滿
          const allFull = data.timeSlots.every(slot => slot.isFull)
          this.dateAvailability[dateStr] = !allFull
          return !allFull
        }
        return true
      } catch (error) {
        console.error('檢查額滿狀態失敗:', error)
        return true
      }
    },

    initCalendar() {

      // 切換RWD樣式/切換樣式
      const layout = this.getLayoutByWidth()

      this.calendar = new Calendar(this.$refs.calendar, {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],

        // // 切換RWD樣式/切換樣式
        headerToolbar: layout.header,
        initialView: layout.view,

        locale: zhTw,

        // 三天樣式
        views: {
          dayGridThreeDay: {
            type: 'dayGrid',
            duration: { days: 3 },
            buttonText: '3天'
          }
        },

        height: "auto",            // ← 不要固定高度
        contentHeight: "auto",     // ← 自動撐開
        expandRows: true,          // ← 顯示完整月曆


        // 不在月曆上渲染事件（你需要純樣式）
        events: [],

        // 日期渲染回呼 → 用來改變日期樣式
        dayCellDidMount: this.decorateDay,

        // 修改日期 拿掉日
        dayCellContent: function (arg) {
          return {
            html: `<div class="fc-daygrid-day-number fc-day-number-only">${arg.date.getDate()}</div>`
          }
        },

        // 切換RWD樣式/切換功能
        windowResize: this.handleResize

      })

      this.calendar.render()

    },

    // 切換RWD樣式/切換樣式
    getLayoutByWidth() {
      const isMobile = window.innerWidth < 767.98

      return {
        isMobile,
        view: isMobile ? 'dayGridThreeDay' : 'dayGridMonth',
        header: isMobile
          ? { left: 'title', center: '', right: 'prev today next' }
          : { left: 'prev', center: 'title', right: 'today next' }
      }
    },

    // 切換RWD樣式/切換功能
    handleResize() {
      const layout = this.getLayoutByWidth()

      this.calendar.changeView(layout.view)
      this.calendar.setOption('headerToolbar', layout.header)
    },


    // 標記日期樣式/顯示文字
    async decorateDay(info) {
      const dayTop = info.el.querySelector('a.fc-daygrid-day-number')
      const frame = info.el.querySelector('.fc-daygrid-day-frame')
      if (!frame || !dayTop) return

      // 清掉舊的
      dayTop.querySelectorAll('.rest-label, .closed-label, .btn_box').forEach(el => el.remove())

      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const cellDate = new Date(info.date)
      cellDate.setHours(0, 0, 0, 0)

      const dateKey = `${cellDate.getFullYear()}-${String(cellDate.getMonth() + 1).padStart(2, '0')}-${String(cellDate.getDate()).padStart(2, '0')}`

      // 休館日（星期三）
      if (info.date.getDay() === REST_DAY) {
        frame.classList.add('closed-off')
        const restTag = document.createElement('span')
        restTag.className = 'rest-label'
        restTag.textContent = this.$t('休館')
        dayTop.appendChild(restTag)
        return
      }

      // 檢查是否為假日（且有描述）
      const holiday = this.isHoliday(info.date)
      if (holiday && holiday.description) {
        frame.classList.add('closingDate')
        const closedBox = document.createElement('div')
        closedBox.className = 'closed-label'
        closedBox.innerHTML = `${holiday.description}<br>${this.$t('整日不開放')}`
        dayTop.appendChild(closedBox)
        return
      }

      // 已截止或自訂截止日期
      if (cellDate <= today) {
        frame.classList.add('closingDate')
        const closedBox = document.createElement('div')
        closedBox.className = 'closed-label'
        closedBox.textContent = this.customClosedDates[dateKey] || this.$t('已截止報名')
        dayTop.appendChild(closedBox)
      } else {
        // 今天以後 → 檢查是否額滿
        const isAvailable = await this.checkDateAvailability(cellDate)
        
        if (!isAvailable) {
          // 額滿
          frame.classList.add('closingDate')
          const closedBox = document.createElement('div')
          closedBox.className = 'closed-label'
          closedBox.textContent = this.$t('本日報名已額滿')
          dayTop.appendChild(closedBox)
        } else {
          // 有名額 → 顯示兩個按鈕
          frame.classList.add('reservation_bate')
          const btnBox = document.createElement('div')
          btnBox.className = 'btn_box'

          const groupBooking = document.createElement('button')
          groupBooking.className = 'reservation_btn'
          groupBooking.textContent = this.$t('團體預約')
          groupBooking.onclick = () => {
            sessionStorage.setItem('reservationDate', dateKey)
            sessionStorage.setItem('regType', '有限制人數')
            this.$router.push({ name: 'ReservationForm' })
          }

          const guidedTour = document.createElement('button')
          guidedTour.className = 'reservation_btn'
          guidedTour.textContent = this.$t('導覽預約')
          guidedTour.onclick = () => {
            sessionStorage.setItem('reservationDate', dateKey)
            sessionStorage.setItem('regType', '無限制人數')
            this.$router.push({ name: 'ReservationForm' })
          }

          btnBox.appendChild(groupBooking)
          btnBox.appendChild(guidedTour)
          dayTop.appendChild(btnBox)
        }
      }

    },




  },

}

</script>
